// ProductosHeader.jsx
import {  Layout } from "antd";
import Header160 from "../../../header/header";

export default function ProductosHeader() {
  return (
    <div className="container" style={{ paddingBottom: 20 }}>
      <Layout className="container">
        <div className="header-filter-container d-flex align-items-center justify-content-between">
          <Header160 />
        </div>
      </Layout>
    </div>
  );
}